export default __webpack_public_path__ + "media/images/favicon/favicon-29138a7be1f3eb2e7dc2005cbef7d3fd.png";